import React from 'react';
import { useIntl } from 'react-intl';

import { Fields } from '~/components/SearchV2/DetailsPanel/Fields/Fields';
import { Panel_DEPRECATED } from '~/eds/src/components/Panel/Panel_DEPRECATED';
import { Action } from '~/eds/src/types/Action';
import { SearchDocumentItem } from '~/features/advanced-search/types';
import { useFormatDate } from '~/i18n/hooks/useFormatDate/useFormatDate';
import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';
import { api } from '~/redux/api/createApi';

type Props = {
  onHide: () => void;
  document?: SearchDocumentItem;
  actions?: Action<unknown>[];
};

export const DetailsPanel = ({ onHide, document, actions }: Props) => {
  const intl = useIntl();
  const formatDate = useFormatDate();
  const formatNumber = useFormatNumber();

  const handler = document?.document_handlers?.[0];
  api.endpoints.getDocumentInformation.useQuery(
    { documentId: handler?.id ?? '', formatDate, formatNumber },
    { skip: !handler },
  );

  if (!document) {
    return null;
  }

  const activeHandler = document.document_handlers[0];

  const tabs = [
    {
      label: intl.formatMessage({
        id: 'DetailsPanel.fieldsTabLabel',
        defaultMessage: 'Fields',
        description: 'Label for fields tab',
      }),
      value: 'fields',
      panel: <Fields handlerId={activeHandler.id} documentId={document.id} />,
    },
  ];

  return (
    <Panel_DEPRECATED
      title={activeHandler.document_name}
      actions={actions}
      isVisible={true}
      onHide={onHide}
      tabs={tabs}
    />
  );
};
